import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {z} from "zod"

export const colorSpace = z.union([z.literal("linear"), z.literal("srgb"), z.literal("lab")])

export type ColorSpace = z.infer<typeof colorSpace>

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            sourceImage: anyImageOpResult,
            sourceColorSpace: colorSpace,
            targetColorSpace: colorSpace,
        }),
    },
}
